import { render } from "./App.vue?vue&type=template&id=1121a5ba&lang=pug"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1121a5ba&lang=less"

import exportComponent from "/Users/jungkyungsuk/Workspaces/hubp-self/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__